module.exports = __webpack_public_path__ + "img/logo.dc3e740.svg";